import { useMsal, useAccount } from "@azure/msal-react";
import { clearSignInMarker } from "pymble-ui/components";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const PLC_AZURE_APIM_CONTACTID = "pymblelcazureapimcontactid";

export type UserDetails = {
  businessPhones?: string[] | null;
  contactid: string;
  displayName: string;
  email: string;
  fullname: string;
  givenName: string;
  id: string;
  jobTitle?: string | null;
  mail?: string | null;
  mobilePhone?: string | null;
  officeLocation?: string | null;
  preferredLanguage?: string | null;
  surname?: string;
  userPrincipalName?: string;
};

/**
 * Hook to fetch user data from microsoft graph api
 */
export function useUserDetails() {
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});

  /**
   * Handle all steps to logout of the app
   */
  const logout = async () => {
    clearSignInMarker(instance.getConfiguration().auth.clientId);
    // Logout from msal
    await instance.logout();
  };

  return {
    instance,
    account,
    accounts,
    inProgress,
    logout,
  };
}
